module.exports = __webpack_public_path__ + "static/img/jxhd-2.e9fb61c9.png";